import { render, staticRenderFns } from "./St21WeekForm.vue?vue&type=template&id=b5eaa04c&"
import script from "./St21WeekForm.vue?vue&type=script&lang=js&"
export * from "./St21WeekForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports